import { gql } from "@apollo/client";

export const AddTicketReason = gql`
  mutation AddTicketReason(
    $token: String!
    $customer_id: ID!
    $user_details: SubscribedUser!
    $input: Reasons!
  ) {
    AddTicketReason(
      token: $token
      customer_id: $customer_id
      user_details: $user_details
      input: $input
    )
  }
`;

export const UpdateTicketReason = gql`
  mutation UpdateTicketReason(
    $token: String!
    $reasons_id: ID!
    $user_details: SubscribedUser!
    $input: Reasons!
  ) {
    UpdateTicketReason(
      token: $token
      reasons_id: $reasons_id
      user_details: $user_details
      input: $input
    )
  }
`;

export const DeleteTicketReason = gql`
  mutation DeleteTicketReason(
    $token: String!
    $reasons_id: ID!
    $user_details: SubscribedUser!
  ) {
    DeleteTicketReason(
      token: $token
      reasons_id: $reasons_id
      user_details: $user_details
    )
  }
`;

export const ReOrderTicketReason = gql`
  mutation ReOrderTicketReason(
    $token: String!
    $customer_id: ID!
    $user_details: SubscribedUser!
    $input: [ReOrderTicketReasons]!
  ) {
    ReOrderTicketReason(
      token: $token
      customer_id: $customer_id
      user_details: $user_details
      input: $input
    )
  }
`;
